import React, { useState } from 'react';
import { DATA_DISCLOSURES, DISCLOSURE_TITLE } from 'containers/constants';

import './DataDisclosure.scss';

const DataDisclosure: React.FC = () => {
    const [open, setOpen] = useState(false);

    return (
        <div className={`data-disclosure${open ? ' open' : ''}`}>
            <button
                type="button"
                className="data-disclosure-toggle"
                aria-expanded={open}
                onClick={() => setOpen((prevState) => !prevState)}
            >
                {DISCLOSURE_TITLE}
                <span className="data-disclosure-chevron" />
            </button>
            {open && (
                <div className="data-disclosure-panel">
                    {DATA_DISCLOSURES.map(({ heading, text }) => (
                        <div className="data-disclosure-section" key={heading}>
                            <p>{heading}</p>
                            <p>{text}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DataDisclosure;
